import { render, staticRenderFns } from "./AccessRightsTable.vue?vue&type=template&id=6c355ddb&scoped=true"
import script from "./AccessRightsTable.vue?vue&type=script&lang=js"
export * from "./AccessRightsTable.vue?vue&type=script&lang=js"
import style0 from "./AccessRightsTable.vue?vue&type=style&index=0&id=6c355ddb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c355ddb",
  null
  
)

export default component.exports